import { useMemo } from "react";
import { Info } from "lucide-react";
import { Button } from "@/components/shadcn/button";
import { NoxusTooltip } from "@/components/UI/NoxusTooltip";
import { formatUtcScheduleTime } from "@/utils/generic";

export const UtcScheduleTimeHint = ({ value }: { value?: string }) => {
  const hint = useMemo(() => formatUtcScheduleTime(value ?? ""), [value]);
  if (!hint) return null;

  return (
    <p className="mt-1.5 flex items-center gap-1 text-xs text-muted-foreground">
      <span>{hint.label}</span>
      {hint.tooltip && (
        <NoxusTooltip content={hint.tooltip} classNameContent="z-1400" asChild>
          <Button
            variant="subtle"
            size="iconxs"
            className="size-4"
            tabIndex={0}
            aria-label="Daylight Saving Time details"
          >
            <Info className="size-3.5" aria-hidden="true" />
          </Button>
        </NoxusTooltip>
      )}
    </p>
  );
};
